module.exports = __webpack_public_path__ + "img/delete.5c97cbe2.svg";